module.exports = __webpack_public_path__ + "static/media/main-slide-3.5c469982.jpg";